import type { HostJoinReminderResponse } from '../utils/hostReminders';
import tgAxios from "@/api/api-axios";
import {
  CreateMeetingPayload,
  MeetingFilter,
  MeetingStatus,
} from "../types/meeting.type";
export const createMeeting = async (payload: CreateMeetingPayload) => {
  const response = await tgAxios.post("/meetings", payload);
  window.dispatchEvent(new Event("meeting-preferences-changed"));
  return response;
};
export const getMeetings = async (params: MeetingFilter) => {
  if (params.page && params.pageSize) {
    const queryString = new URLSearchParams();
    queryString.set("page", params.page.toString());
    queryString.set("pageSize", params.pageSize.toString());
    if (params.status !== MeetingStatus.ALL) {
      queryString.set("statuses", params.status!.toString());
    }
    if (params.search) {
      queryString.set("search", params.search);
    }
    if (params.roomMeetingId && params.roomMeetingId !== "all") {
      queryString.set("roomMeetingIds", params.roomMeetingId);
    }
    if (params.startDate) {
      queryString.set("startDate", params.startDate);
    }
    if (params.endDate) {
      queryString.set("endDate", params.endDate);
    }
    return tgAxios.get(`/meetings?${queryString.toString()}`);
  }
  return tgAxios.get("/meetings");
};
export const getMeetingById = async (id: string) => {
  return tgAxios.get(`/meetings/${id}`);
};
export const getMeetingStatistics = async () => {
  return tgAxios.get(`/meetings/statistics`);
};
export const startMeetingApi = async (id: string) => {
  return tgAxios.patch(`/meetings/${id}/start`);
};
export const stopMeetingApi = async (id: string) => {
  const response = await tgAxios.patch(`/meetings/end/${id}`);
  window.dispatchEvent(new CustomEvent('meeting-ended', {detail: {id}}));
  return response;
};
export const deleteMeetingApi = async (id: string) => {
  return tgAxios.delete(`/meetings/${id}`);
};
export const updateMeeting = async (
  id: string,
  payload: Partial<CreateMeetingPayload>
) => {
  const response = await tgAxios.patch(`/meetings/${id}`, payload);
  window.dispatchEvent(new Event("meeting-preferences-changed"));
  return response;
};

// Lấy LiveKit token để join meeting
export const getLivekitTokenApi = async ({
  meetingCode,
  participantIdentity,
  participantName,
  role,
  metadata,
}: {
  meetingCode: string;
  participantIdentity: string;
  participantName: string;
  role: string;
  metadata?: Record<string, string>;
}) => {
  return tgAxios.post<{ token: string; serverUrl: string }>(
    `/meetings/generate-token/${meetingCode}`,
    {
      participantIdentity,
      participantName,
      role,
      metadata: JSON.stringify(metadata),
    }
  );
};
export const startRecordingMeetingApi = async (
  id: string,
  payload: {
    layout?: string;
    encodingPreset?: string;
    customEncoding?: {
      width?: number;
      height?: number;
      bitrate?: number;
      frameRate?: number;
      videoBitrate?: number;
      audioBitrate?: number;
      audioSampleRate?: number;
      audioFrequency?: number;
      keyFrameInterval?: number;
    };
    audioOnly?: boolean;
    videoOnly?: boolean;
    audioMixing?: string;
    fileType?: string;
    fileNamePrefix?: string;
    s3Folder?: string;
  }
) => {
  return tgAxios.post(`/meetings/${id}/recording/start`, payload);
};
export const stopRecordingMeetingApi = async (
  id: string,
  payload: { egressId: string }
  //Specific egress ID to stop (if not provided, stops all recordings for the meeting)
) => {
  return tgAxios.post(`/meetings/${id}/recording/stop`, payload);
};

export const updateRecordingLayoutApi = async (meetingId: string, payload: { 
  egressId: string;
  layout: string;
}) => {
  return tgAxios.patch(`/meetings/${meetingId}/recording/layout`, payload);
};
export const getRecordingsMeetingApi = async (id: string) => {
  return tgAxios.get(`/meetings/${id}/recordings`);
};


export const startStreamingMeetingApi = async (
  id: string,
  payload: {
    streamUrls: string[];
    layout?: string;
    encodingPreset?: string;
    customEncoding?: {
      width?: number;
      height?: number;
      bitrate?: number;
      frameRate?: number;
      videoBitrate?: number;
      audioBitrate?: number;
      audioSampleRate?: number;
      audioFrequency?: number;
      keyFrameInterval?: number;
    };
    audioOnly?: boolean;
    videoOnly?: boolean;
    audioMixing?: string;
    customBaseUrl?: string;
  }
) => {
  return tgAxios.post(`/meetings/${id}/stream/start`, payload);
};
export const stopStreamingMeetingApi = async (
  id: string,
  payload: { egressId: string }
  //Specific egress ID to stop (if not provided, stops all recordings for the meeting)
) => {
  return tgAxios.post(`/meetings/${id}/stream/stop`, payload);
};
export const getStreamingsMeetingApi = async (id: string) => {
  return tgAxios.get(`/meetings/${id}/streams`);
};

export const updateStreamingLayoutApi = async (meetingId: string, payload: { 
  egressId: string;
  layout: string;
}) => {
  return tgAxios.patch(`/meetings/${meetingId}/stream/layout`, payload);
};
export const getHostJoinReminders = (signal?: AbortSignal) =>
  tgAxios.get<HostJoinReminderResponse>("/meetings/host-join-reminders", {signal});
